import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  tokenFromUI: string = 'HuloopAgentSec@!';
  encrypted: any = '';
  request: string;
  responce: string;

  encryptedRequest: string;
  decrypted: any = '';
  constructor(
    private userService:UserService
  ) {
    // this.encryptUsingAES128();
  }
  encryptUsingAES128(request) {
    let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
    let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
    let encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(request),
      _key,
      {
        keySize: 16,
        iv: _iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    this.encrypted = encrypted.toString();
    return this.encrypted;
  }

  decryptUsingAES128(encryptedRequest) {
    let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
    let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
    let decrypted = CryptoJS.AES.decrypt(encryptedRequest, _key, {
      keySize: 16,
      iv: _iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    this.decrypted = decrypted.toString(CryptoJS.enc.Utf8);
    console.log('hello', this.decrypted);
    
    return this.decrypted;
  }

  encrypt(str, key='PassworD009Sec@!') {
    return CryptoJS.AES.encrypt(str, key).toString();
  }
  
  decrypt(encrypted, key='PassworD009Sec@!') {
    const decrypted = CryptoJS.AES.decrypt(encrypted, key);
    if(decrypted==undefined){
      this.userService.logoutUser();
    }
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  finalEncryption;
  encoder(str) {
    let encoder = new TextEncoder();
    let byteArray = encoder.encode(str)
    return CryptoJS.enc.Utf8.parse(str)
  }

  toWordArray(str) {
    return CryptoJS.enc.Utf8.parse(str);
  }

  encryptB(value) {
    return value;
  }

  decryptB(value) {
    return value;
  }

}
